import OutOfBoundsException from '../../Exceptions/OutOfBoundsException';
export function ensureInt(value, minValue, maxValue) {
    if (value > maxValue || value < minValue) {
        throw new OutOfBoundsException('value', minValue, maxValue);
    }
}
